;
define("product_views_option_checkbox.tpl", function(){});

